import { isEqual } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, OrderItem } from '@mews-commander/types';
import { ServiceOrder } from '@mews-commander/data-access';
import { getUngroupableOrderItemsByBillId, getUnlinkedOrderedServiceOrders } from '../../../../selectors';

interface StateProps {
    serviceOrders: ServiceOrder[];
    ungroupedOrderItems: OrderItem[];
}

interface OwnProps {
    billId: string;
}

export const connectServiceList = connect<StateProps, null, OwnProps, ApplicationState>(
    createStructuredSelector({
        serviceOrders: (state: ApplicationState, { billId }: OwnProps) =>
            getUnlinkedOrderedServiceOrders(state, { billId, billIds: [billId] }),
        ungroupedOrderItems: (state: ApplicationState, { billId }: OwnProps) =>
            getUngroupableOrderItemsByBillId(state, { billId }),
    }),
    null,
    null,
    {
        areStatePropsEqual: isEqual,
    }
);
